module.exports = __webpack_public_path__ + "assets/img/icon_list.a63c6948.svg";